import React, { useContext } from 'react';
import modalContext from '../../context/modal/modalContext';
import CustomModal from '../../components/CustomModal';
import { CrossIcon } from '../../assets/icons';
import appContext from '../../context/app/appContext';

const RiskModelDetails: React.FC = () => {
    const { closeModal } = useContext(modalContext);
    const onClose = () => closeModal('riskModelDetails');

    const { currentViewingRiskModel, chainRiskModels } = useContext(appContext);

    if (!currentViewingRiskModel) return null;

    const MODEL = chainRiskModels[currentViewingRiskModel];

    return (
        <CustomModal modalName='riskModelDetails' className='risk-model-details'>
            <div className='title'>
                Risk Model Details - {MODEL?.name ?? 'Risk Model'}
            </div>
            <button type='button' onClick={onClose}>
                <CrossIcon />
            </button>
            <div
                className='content'
                dangerouslySetInnerHTML={{
                    __html: MODEL?.fullDetails ?? 'Model Details',
                }}
            />
        </CustomModal>
    );
};

export default RiskModelDetails;
